import { createSectionFactory } from "@hydrologiq/shared/createSection"
import Routing from "@hydrologiq/alerts/Routing"
import defaultCopy from "./copy"
import { section, graphqlUri, restEndpoint, graphqlUriLegacy } from "./config"
import { TenantProfile } from "@hydrologiq/gql/graphql"
import alertsCss from "./index.scss?inline"

const profile = TenantProfile.Rental
// const profile = TenantProfile.FuelProducer

// Create the section using the generic factory
const createSection = createSectionFactory({
  sectionName: "alerts",
  section: section,
  RoutingComponent: Routing,
  defaultCopy,
  defaultFeatures: undefined,
  graphqlUri,
  restEndpoint,
  primaryGraphqlUri: graphqlUri,
  legacyGraphqlUri: graphqlUriLegacy,
  profile: profile,
  sectionCss: alertsCss,
})

export default createSection